import { useFormikContext } from 'formik';
import { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Dropdown from '../../../../../../components/Dropdown/Dropdown';
import { useAppDispatch, useAppSelector } from '../../../../../../reduxService/hooks';
import { fetchMaterialById } from '../../../../../store/material/materialDetailSlice';
import { selectProject } from '../../../../selector/conversion';
import { IFormikForm } from '../ModalMaterial/FormikMaterial';

export interface IMaterialSectorFormik {
    sectorChannel?: number;
    set?: any;
}

export const MaterialSectorFormik = (props: IMaterialSectorFormik) => {
    const { t } = useTranslation();
    const { values, setFieldValue } = useFormikContext<IFormikForm>();
    const dispatch = useAppDispatch();
    const project = useAppSelector(selectProject);

    const optionSectors = project.data!.geometry!.map(sec => ({ label: sec.channel.toString(), value: sec.channel })).sort((a, b) => a.value - b.value);
    const handleMaterialClick = useCallback(async (id: any) => {
        dispatch(fetchMaterialById(id));
    }, []);

    useEffect(() => {
        let materialId = values[values.sectorChannel].material?.baseMaterialId || values[values.sectorChannel].material?.id;
        if (materialId) {
            handleMaterialClick(materialId);
        }
    }, [values.sectorChannel]);

    return (
        <Dropdown
            title={t('sector')}
            name='sectorChannel'
            className='d-flex flex-column'
            disabled={!!props.sectorChannel}
            defaultValue={values.sectorChannel}
            options={optionSectors}
            onChange={e => {
                setFieldValue(`sectorChannel`, parseInt(e.target.value));
                if (!!props.set) props.set();
            }}
        />
    );
};
